/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from "@mui/material";
import React, { useEffect, useState, ReactElement } from "react";
import axios from "axios";
import { FaPlus } from "react-icons/fa";
import { Badge, Button } from "@chakra-ui/react";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridClasses,
} from "@mui/x-data-grid";
import CreateUserModal from "./modal/CreateUserModal";
import { Auth } from "aws-amplify";
import moment from "moment";
import UserTableSearch from "./UserTableSearch";
import SweetAlert2 from "react-sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import { Tooltip, IconButton } from "@mui/material";
import { AiOutlineFileSearch } from "react-icons/ai";
import { MdOutlineDoNotDisturbAlt } from "react-icons/md";
import { AiOutlineCheckCircle } from "react-icons/ai";
import UserUpdateStatusConfirmModal from "../../shared/UserUpdateStatusConfirmModal";
import UserToolbar from "./UserToolbar";

type User = {
  user_id: string;
  username: string;
  email: string;
  role: string;
  status: string;
  merchant: any;
  subaccount: any;
  created_date: string;
  latest_login: string;
};

const UserTable: React.FC<{
  isLoading: boolean;
  tableData: any;
  setRowCount: React.Dispatch<React.SetStateAction<number>>;
  setTableData: React.Dispatch<React.SetStateAction<any>>;
  page: number;
  pageSize: number;
  rowCount: number;
  setPaginationModel: any;
  currentUsername: string;
  currentUserRole: any;
  handleSearch: any;
  handleClear: any;
  initialFilters: any;
  filters: any;
  setFilters: any;
  setIsLoading: any;
  fetchUsers: any;
  triggerReloadUserList: () => void;
}> = ({
  isLoading,
  tableData,
  setTableData,
  page,
  pageSize,
  rowCount,
  setPaginationModel,
  setRowCount,
  currentUsername,
  currentUserRole,
  handleSearch,
  handleClear,
  initialFilters,
  filters,
  setFilters,
  setIsLoading,
  fetchUsers,
  triggerReloadUserList
}) => {
    const [merchants, setMerchants] = useState([]);
    const [agents, setAgents] = useState([]);
    const [subaccounts, setSubaccounts] = useState([]);
    const [isSetSubaccounts, setIsSetSubaccounts] = useState(false);
    const [roleHierarchy, setRoleHierarchy] = useState([]);
    const [isOpenCreateUserModal, setIsOpenCreateUserModal] = useState(false);
    const [roleOptions, setRoleOptions] = useState<string[]>([]);
    const [showFilters, setShowFilters] = useState<boolean>(false);
    const toggleFilters = () => setShowFilters((prev: boolean) => !prev);
    const [newUser, setNewUser] = useState<any>({
      username: "",
      email: "",
      role: "",
    });

    const navigate = useNavigate();
    const userRole = localStorage.getItem("userRole")?.toLowerCase();
    const sysUsername = localStorage.getItem("username")?.toLowerCase();
    const userid = localStorage.getItem("userid")?.toLowerCase();
    const subaccountId = localStorage.getItem("subaccountId")?.toLowerCase();

    const [isOpenUpdateStatusConfirmModal, setIsOpenUpdateStatusConfirmModal] =
      useState<boolean>(false);
    const [statusToUpdate, setStatusToUpdate] = useState<string>("");
    const [userDetailToUpdate, setUserDetailToUpdate] = useState(null);

    const resetNewUser = () => {
      setNewUser({
        username: "",
        email: "",
        role: "",
        merchant: "",
        subaccount: "",
        agent: "",
      });
    };

    useEffect(() => {
      const fetchData = async () => {
        const fetchedMerchants = await getMerchantOptions();
        setMerchants(fetchedMerchants);

        const fetchedAgents = await getAgentOptions();
        setAgents(fetchedAgents);
      };

      fetchData();
    }, []);

    useEffect(() => {
      const fetchRoleOptions = async () => {
        const fetchedRoleOptions = await getRoleOptions();
        setRoleOptions(fetchedRoleOptions);
      };

      fetchRoleOptions();
    }, []);

    const getRoleOptions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/user/get-all-hierarchy-levels`
        );
        const roles = response.data;

        const currentRole = roles.find(
          (role: any) => role.name === currentUserRole
        );

        if (!currentRole) {
          return ["-- Please Select --"];
        }

        const roleOptionsArray = ["-- Please Select --"];

        roles.forEach((role: any) => {
          if (role.hierarchy_level !== 3) {
            roleOptionsArray.push(role.name);
          }
        });

        return roleOptionsArray;
      } catch (error) {
        console.error("Error fetching role options:", error);
        return [];
      }
    };

    const getMerchantOptions = async () => {
      try {
        if (currentUserRole === "SuperAdmin") {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/merchant/all-merchants`
          );
          if (response.data.merchants && response.data.merchants.payload) {
            return [
              { id: "", name: "-- Please Select --" },
              ...response.data.merchants.payload,
            ];
          } else {
            console.error("Invalid response format for get-all-merchants");
            return [{ id: "", name: "-- Please Select --" }];
          }
        } else {
          const session = await Auth.currentSession();
          const idToken = session.getIdToken();
          const cognitoId = idToken.payload.sub;

          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/merchant/get-merchants-for-user?cognitoId=${cognitoId}`
          );

          if (response.data.merchants && response.data.merchants.payload) {
            return [
              { id: "", name: "-- Please Select --" },
              ...response.data.merchants.payload,
            ];
          } else {
            console.error("Invalid response format for get-merchants-for-user");
            return [{ id: "", name: "-- Please Select --" }];
          }
        }
      } catch (error) {
        console.error(error);
        return [];
      }
    };

    const getAgentOptions = async () => {
      localStorage.removeItem("agentName");
      try {
        if (currentUserRole === "SuperAdmin") {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/datasource/agents`
          );
          if (response.data.agents && response.data.agents.payload) {
            return [
              { id: "", name: "-- Please Select --" },
              ...response.data.agents.payload,
            ];
          } else {
            console.error("Invalid response format for get-all-agents");
            return [{ id: "", name: "-- Please Select --" }];
          }
        } else {
          const session = await Auth.currentSession();
          const idToken = session.getIdToken();
          const cognitoId = idToken.payload.sub;

          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/merchant/get-merchants-for-user?cognitoId=${cognitoId}`
          );

          if (response.data.merchants && response.data.merchants.payload) {
            return [
              { id: "", name: "-- Please Select --" },
              ...response.data.merchants.payload,
            ];
          } else {
            console.error("Invalid response format for get-merchants-for-user");
            return [{ id: "", name: "-- Please Select --" }];
          }
        }
      } catch (error) {
        console.error(error);
        return [];
      }
    };

    const getSubaccountOptions = async (merchantId: any) => {
      try {
        if (currentUserRole === "SuperAdmin") {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/subaccount/get-all-subaccounts-for-merchant?merchantId=${merchantId}`
          );
          return [
            { id: "", suba_name: "-- Please Select --" },
            ...response.data?.subaccounts,
          ];
        } else {
          const session = await Auth.currentSession();
          const idToken = session.getIdToken();
          const cognitoId = idToken.payload.sub;

          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/subaccount/get-all-subaccounts-user?cognitoId=${cognitoId}&merchantId=${merchantId}`
          );
          return [
            { id: "", suba_name: "-- Please Select --" },
            ...response.data?.subaccounts,
          ];
        }
      } catch (error) {
        console.error(error);
        return [];
      }
    };

    useEffect(() => {
      const fetchRoleHierarchy = async () => {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + "/api/user/get-all-hierarchy-levels"
        );
        setRoleHierarchy(response.data);
      };

      fetchRoleHierarchy();
    }, []);

    const [selectedUser, setSelectedUser] = useState<any>(null);

    const handleStatusChange = (
      email: string,
      username: string,
      currentStatus: string
    ) => {
      setSelectedUser({ email, username, status: currentStatus });
      setIsStatusModalOpen(true);
    };

    const [isConfirming, setIsConfirming] = useState(false);

    const handleInputChange = async (event: any) => {
      const { name, value } = event.target;

      let updatedUser = { ...newUser, [name]: value };
      if (name === "role" && value === "Agent") {
        setSubaccounts([]);
        updatedUser = {
          ...updatedUser,
          merchant: "",
          subaccount: "",
          agent: "",
        };
      } else if (name === "role" && value === "SuperAdmin") {
        setSubaccounts([]);
        updatedUser = {
          ...updatedUser,
          merchant: "",
          subaccount: "",
          agent: "",
        };
      } else if (name === "role" && value === "Merchant") {
        setSubaccounts([]);
        updatedUser = {
          ...updatedUser,
          subaccount: "",
          agent: "",
        };
      } else if (name === "role" && value !== "Agent" && value !== "SuperAdmin") {
        setSubaccounts([]);
        updatedUser = {
          ...updatedUser,
          agent: "",
        };
      }

      setNewUser(updatedUser);

      if (name === "merchant") {
        setIsSetSubaccounts(true);
        const fetchedSubaccounts = await getSubaccountOptions(value);
        setSubaccounts(fetchedSubaccounts);
        setIsSetSubaccounts(false);
      }
    };

    const [editingUser, setEditingUser] = useState(null);

    useEffect(() => {
      const storedSelectedUser = localStorage.getItem("selectedUser");
      if (storedSelectedUser) {
        setSelectedUser(JSON.parse(storedSelectedUser));
        setEditingUser(true);
      }
    }, []);

    const handleViewDetail = (userId: any) => {
      const user = tableData.filter((x: any) => x.user_id === userId)[0];
      if (user.agentId) {
        const agentId = user.agentId;
        const agent = agents.filter((x: any) => x.id === agentId)[0];
        localStorage.setItem("agentName", agent.name);
      }
      navigate(`/${userRole}/user-management/${userId}`);
    };

    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [swalProps, setSwalProps] = useState<any>({});

    // Convert PascalCase/camelCase to kebab-case (e.g., SuperAdmin → super-admin)
    const toKebabCase = (str: string) => {
      return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    };

    const handleSubmit = async (e: any) => {
      const { username, email, role, merchant, subaccount, agent } = newUser;

      const usernameRegex = /^[a-z0-9]+$/;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!usernameRegex.test(username)) {
        setSwalProps({
          show: true,
          icon: "error",
          title: "Oops!",
          html: "Username must contain only letters (a-z) with no spaces or special characters.",
          showConfirmButton: true,
          didClose: () => {
            setSwalProps({});
            setIsSubmitting(false);
          },
        });
        return;
      }

      if (!emailRegex.test(email)) {
        setSwalProps({
          show: true,
          icon: "error",
          title: "Oops!",
          html: "Please enter a valid email address (e.g., user@example.com).",
          showConfirmButton: true,
          didClose: () => {
            setSwalProps({});
            setIsSubmitting(false);
          },
        });
        return;
      }

      const userRole = localStorage.getItem("userRole")?.toLowerCase();
      const sysUsername = localStorage.getItem("username")?.toLowerCase();

      setIsSubmitting(true);
      try {
        const postData: any = {
          username,
          email,
          role,
          merchantId: merchant,
          agentId: agent,
          userRole,
          sysUsername,
        };
        if (role !== "Merchant") {
          postData.subaccountId = subaccount;
        }

        await axios.post(
          process.env.REACT_APP_API_URL + `/api/${userRole}/user/action/add-${toKebabCase(role)}`,
          postData
        ).then(function (response) {
          closeCreateUserModal();
          setSwalProps({
            show: true,
            icon: "success",
            title: "Success",
            html: "User successfully created!",
            showConfirmButton: true,
            didClose: () => {
              setNewUser({
                username: "",
                email: "",
                role: "",
                merchant: "",
                subaccount: "",
                agent: "",
              });
              setSubaccounts([]);
              handleClear();
              setSwalProps({});
              setIsSubmitting(false);
            },
          });
        })
          .catch(function (error) {
            resetNewUser();
            setSubaccounts([]);
            closeCreateUserModal();
            setSwalProps({
              show: true,
              icon: "error",
              title: "Oops!",
              html: error.response?.data?.message
                ? error.response.data.message
                : "Failed to create new user, please try again.",
              showConfirmButton: true,
              didClose: () => {
                setSwalProps({});
                setIsSubmitting(false);
              },
            });
          });
      } catch (error) {
        resetNewUser();
        setSubaccounts([]);
        closeCreateUserModal();
        setSwalProps({
          show: true,
          icon: "error",
          title: "Oops!",
          html: "Failed to create new user, please try again.",
          showConfirmButton: true,
          didClose: () => {
            setSwalProps({});
            setIsSubmitting(false);
          },
        });
      }
    };

    interface UserStatusItems {
      status: string;
      value: string;
      display: ReactElement;
    }

    const statusClasses = "status";

    const statusList: UserStatusItems[] = [
      {
        status: "Inactive",
        value: "inactive",
        display: (
          <Badge className={`${statusClasses} status-inactive`}>Inactive</Badge>
        ),
      },
      {
        status: "Active",
        value: "active",
        display: (
          <Badge className={`${statusClasses} status-active`}>Active</Badge>
        ),
      },
    ];

    const formatDate = (dateString: string) => {
      return moment(dateString, "YYYY-MM-DD HH:mm:ss").format(
        "DD MMM YY - hh:mm A"
      );
    };

    const columns: GridColDef[] = [
      {
        field: "email",
        headerName: "Email",
        flex: 1,
        minWidth: 220,
        sortable: false,
        renderCell: (params: GridRenderCellParams<User, string>) => {
          const isCurrentUser = params.row.username === currentUsername;
          return (
            <span className={isCurrentUser ? "font-bold" : ""}>
              {params.value}
            </span>
          );
        },
      },
      {
        field: "username",
        headerName: "Username",
        flex: 1,
        minWidth: 220,
        sortable: false,
        renderCell: (params: GridRenderCellParams<User, string>) => {
          const isCurrentUser = params.row.username === currentUsername;
          return (
            <span className={isCurrentUser ? "font-bold" : ""}>
              {params.value}
            </span>
          );
        },
      },
      {
        field: "latest_login",
        headerName: "Latest Login",
        flex: 1,
        minWidth: 220,
        sortable: false,
        valueFormatter: (params) => {
          const dateString = params.value as string;
          if (!dateString) return "-";
          return formatDate(dateString);
        },
      },
      {
        field: "status",
        headerName: "",
        flex: 1,
        minWidth: 140,
        sortable: false,
        headerAlign: "center",
        align: "center",
        renderCell: (params: GridRenderCellParams<User, string>) => {
          const status = params.value as string;
          const statusItem = statusList.find((item) => item.status === status);
          return statusItem ? statusItem.display : null;
        },
      },
      {
        field: "actions",
        headerName: " ",
        flex: 1,
        minWidth: 220,
        sortable: false,
        headerAlign: "right",
        align: "right",
        renderCell: (params: GridRenderCellParams<User, string>) => (
          <div className="flex items-center">
            <>
              <Tooltip title="View More Details" arrow placement="top">
                <IconButton
                  component={Link}
                  to={`/${userRole}/user-management/${params?.row?.user_id}`}
                  disabled={isLoading}
                  id={"button-detail-" + params?.row?.user_id}
                  onClick={() => {
                    const user = tableData.filter((x: any) => x.user_id === params?.row?.user_id)[0];
                    if (user?.agentId) {
                      const agent = agents.filter((x: any) => x.id === user.agentId)[0];
                      if (agent) localStorage.setItem("agentName", agent.name);
                    }
                  }}
                >
                  <AiOutlineFileSearch className="h-5 w-5 text-navy-700" />
                </IconButton>
              </Tooltip>
              {Number(userid) !== Number(params?.row?.user_id) &&
                <Tooltip
                  title={params.row.status === "Active" ? "Deactivate" : "Activate"}
                  arrow
                  placement="top"
                >
                  <IconButton
                    disabled={isLoading}
                    id={"button-change-status-" + params?.row?.user_id}
                    onClick={() =>
                      handleUpdateStatus(
                        params.row.status === "Active" ? "inactive" : "active",
                        params?.row?.user_id
                      )
                    }
                  >
                    {params.row.status === "Active" ? (
                      <MdOutlineDoNotDisturbAlt className="h-5 w-5 text-red-500" />
                    ) : (
                      <AiOutlineCheckCircle className="h-5 w-5 text-primary-500" />
                    )}
                  </IconButton>
                </Tooltip>
              }
            </>
          </div>
        ),
      },
    ];

    const customDataGridStyles: Partial<GridClasses> = {
      root: "mui-table-custom",
      columnHeader: "text-start text-md",
      row: "",
    };

    const handleUpdateStatus = (statusToUpdate: string, user_id: any) => {
      const user = tableData.filter((x: any) => x.user_id === user_id)[0];
      setUserDetailToUpdate(user);
      setStatusToUpdate(statusToUpdate);
      showUpdateStatusConfirmModal();
    };

    const showUpdateStatusConfirmModal = () => {
      setIsOpenUpdateStatusConfirmModal(true);
    };

    const closeUpdateStatusConfirmModal = () => {
      setIsOpenUpdateStatusConfirmModal(false);
    };

    const closeCreateUserModal = () => {
      setIsOpenCreateUserModal(false);
    };

    const triggerReloadList = async () => {
      setUserDetailToUpdate(null);
      setStatusToUpdate("");
      setIsLoading(true);
      await fetchUsers(true);
    };

    const createNewUser = async () => {
      setIsOpenCreateUserModal(true);
    };

    return (
      <div>
        {isOpenUpdateStatusConfirmModal && userDetailToUpdate && (
          <UserUpdateStatusConfirmModal
            setSwalProps={setSwalProps}
            triggerReload={triggerReloadList}
            isOpen={isOpenUpdateStatusConfirmModal}
            onClose={closeUpdateStatusConfirmModal}
            userToUpdate={userDetailToUpdate}
            statusToUpdate={statusToUpdate}
          />
        )}
        <SweetAlert2 {...swalProps} />

        <>
          <UserToolbar
            isLoading={isLoading}
            onToggleFilters={toggleFilters}
            onRefresh={triggerReloadUserList}
            onCreateNewUser={createNewUser}
          />

          <UserTableSearch
            showFilters={showFilters}
            initialFilters={initialFilters}
            filters={filters}
            setFilters={setFilters}
            onSearch={handleSearch}
            onClear={handleClear}
            isLoading={isLoading}
            isConfirming={isConfirming}
          />

          <Box className="card w-full">
            <DataGrid
              sx={{
                "& .MuiDataGrid-cell": {
                  padding: "8px 16px",
                },
                "& .MuiDataGrid-columnHeader": {
                  padding: "8px 16px",
                },
                "& .MuiTablePagination-input": {
                  marginRight: "-20px",
                },
                "& .MuiTablePagination-displayedRows": {
                  display: "none",
                },
              }}
              loading={isLoading || !agents}
              rows={tableData || []}
              columns={columns}
              getRowId={(row) => (row ? row.email : undefined)}
              rowCount={rowCount}
              sortingMode="server"
              paginationMode="server"
              pageSizeOptions={[10, 25, 50, 100]}
              rowHeight={48}
              columnHeaderHeight={48}
              paginationModel={{ page: page, pageSize: pageSize }}
              onPaginationModelChange={(newValue) => setPaginationModel(newValue)}
              disableRowSelectionOnClick
              disableColumnFilter
              disableColumnMenu
              classes={customDataGridStyles}
              getCellClassName={(params) => {
                if (params.row.username === currentUsername) {
                  return "text-primary-500";
                }
                return "";
              }}
              autoHeight
              localeText={{
                noRowsLabel: "No data available",
              }}
            />
          </Box>

          {isOpenCreateUserModal &&
            <CreateUserModal
              isOpen={isOpenCreateUserModal}
              onClose={closeCreateUserModal}
              handleSubmit={handleSubmit}
              newUser={newUser}
              handleInputChange={handleInputChange}
              roleOptions={roleOptions}
              merchants={merchants}
              agents={agents}
              subaccounts={subaccounts}
              resetNewUser={resetNewUser}
              isSubmitting={isSubmitting}
              isSetSubaccounts={isSetSubaccounts}
              setSubaccounts={setSubaccounts}
            />
          }
        </>
      </div>
    );
  };

export default UserTable;
